import {CustomerContact} from '../customer-contact.model';
import {Address} from '../../../address/models/address.model';
import {CustomerIdentification} from '../customer-identification.model';
import {CustomerName} from '../customer-name.model';

export class SimpleOrganization {

    public id: number;
    public organizationTypeId: number;
    public dateOfBirth: any;
    public name: CustomerName;
    public ein: CustomerIdentification;
    public oin: CustomerIdentification;
    public businessCell: CustomerContact;
    public businessEmail: CustomerContact;
    public organizationAddress: Address;
    public override: boolean;

}
